export default "__VITE_PUBLIC_ASSET__6d7358cd__"